import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { ConfirmationDialogComponent } from "./confirmation-dialog.component";

@NgModule({
  imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule],
  declarations: [ConfirmationDialogComponent],
  exports: [ConfirmationDialogComponent]
})
export class ConfirmationDialogModule {}
